import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {useShowCampaignPhonePopup} from '@aboutyou/logic-components';

export const PhonePopupLegacy = lazy(() =>
  import('./PhonePopup.eager').then(mod => ({default: mod.PhonePopup})),
);

export const PhonePopupConditional = () => {
  const showPhonePopup = useShowCampaignPhonePopup();

  return showPhonePopup ? <PhonePopupLegacy /> : null;
};
